import { useColorSchemeDetector } from 'generic/core/hooks/useColorSchemeDetector';
import { getRandomColor } from 'generic/utils/colorUtils';
import _ from 'lodash';

const useComputedTranscription = (rawTextJSON, rawTranslation) => {
  const currentTheme = useColorSchemeDetector();
  if (_.isEmpty(rawTextJSON)) {
    return null;
  }

  let translatedSentences = [];
  if (!_.isEmpty(rawTranslation) && rawTranslation.indexOf('\n') !== -1) {
    translatedSentences = rawTranslation.split('\n');
  }

  const transcription = {
    speakers: {},
    sentences: [],
  };

  const parsedSentences = JSON.parse(rawTextJSON);

  // on copie les traductions uniquement ssi phrases et traductions ont le même nombre d'éléments
  if (_.isArray(parsedSentences)) {
    // on copie les phrases
    const enoughTranslations = (translatedSentences.length === parsedSentences.length);
    transcription.sentences = parsedSentences.map((sentence, index) => ({
      ...sentence,
      translation: enoughTranslations ? translatedSentences[index] : null,
    }));

    // on génère des couleurs pour tous les speakers en s'assurant d'au moins toujours utiliser nos couleurs avant d'en
    // générer de nouvelle (ça laisse moins de chance de tomber sur du vert ou du rouge)
    const { speakersColors } = currentTheme.HIGHCHARTS;
    const speakerIds = new Set(parsedSentences.map((sentence) => sentence.spkid).filter((spkid) => !!spkid));
    [...speakerIds].sort().forEach((speaker, index) => {
      const color = speakersColors[index] || getRandomColor(index, 'hexa');
      transcription.speakers[speaker] = color;
    });
  }

  return transcription;
};

// eslint-disable-next-line import/prefer-default-export
export { useComputedTranscription };
